/* 言語プレフィックス（/en）が付いていない内部リンクを補正する。
   テーマ設定のリッチテキストなど Liquid で書き換えられない箇所のための保険。
   日本語版（プレフィックスなし）では何もしない。 */
(function () {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  if (root === '/') return;                 // 既定の言語＝補正不要
  var prefix = root.replace(/\/$/, '');     // '/en/' -> '/en'

  // 言語で切り替える対象のパス。/cdn などテーマ資産は触らない。
  var TARGET = /^\/(pages|products|collections|blogs|cart|search|account|policies)(\/|$|\?)/;

  function fix(el, attr) {
    var v = el.getAttribute(attr);
    if (!v || !TARGET.test(v)) return;
    el.setAttribute(attr, prefix + v);
  }

  function run(scope) {
    var nodes = (scope || document).querySelectorAll('a[href], form[action]');
    Array.prototype.forEach.call(nodes, function (el) {
      fix(el, el.tagName === 'FORM' ? 'action' : 'href');
    });
  }

  document.addEventListener('DOMContentLoaded', function () { run(document); });
  // 後から差し込まれる要素（ミニカート等）にも効かせる
  var mo = new MutationObserver(function (list) {
    list.forEach(function (m) {
      if (m.type === 'attributes' && m.target && m.target.nodeType === 1) {
        fix(m.target, m.attributeName);
        return;
      }
      Array.prototype.forEach.call(m.addedNodes, function (n) {
        if (n.nodeType !== 1) return;
        if (n.matches && n.matches('a[href], form[action]')) fix(n, n.tagName === 'FORM' ? 'action' : 'href');
        if (n.querySelectorAll) run(n);
      });
    });
  });
  document.addEventListener('DOMContentLoaded', function () {
    // アプリ（Zepto 等）が後から action を書き戻すことがあるので属性の変更も見る。
    // 直したあとの値は対象パターンに当たらないので無限ループにはならない。
    mo.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['href', 'action'] });
  });
})();
